// CPC — sign @mysten/sui Transaction via Wallet Standard (dapp-kit 0.12 lacks useSignAndExecuteTransaction).
import { useCurrentAccount, useCurrentWallet } from '@mysten/dapp-kit';
import { useMutation } from '@tanstack/react-query';

const SIGN_AND_EXECUTE = 'sui:signAndExecuteTransaction';
const SIGN_AND_EXECUTE_BLOCK = 'sui:signAndExecuteTransactionBlock';

export type CpcSignableTransaction = {
	toJSON(): Promise<string>;
};

export type CpcSignAndExecuteResult = {
	digest: string;
	signature?: string;
};

export function useCpcSignAndExecuteTransaction() {
	const { currentWallet } = useCurrentWallet();
	const account = useCurrentAccount();

	return useMutation({
		mutationFn: async ({
			transaction,
		}: {
			transaction: CpcSignableTransaction;
		}): Promise<CpcSignAndExecuteResult> => {
			if (!currentWallet) {
				throw new Error('请先连接 RWAX Wallet');
			}
			if (!account) {
				throw new Error('未选择钱包账户');
			}
			const chain = account.chains[0];
			if (!chain) {
				throw new Error('钱包账户缺少 chain');
			}

			const v2 = currentWallet.features[SIGN_AND_EXECUTE] as
				| {
						signAndExecuteTransaction: (input: {
							transaction: CpcSignableTransaction;
							account: typeof account;
							chain: string;
						}) => Promise<CpcSignAndExecuteResult>;
				  }
				| undefined;
			if (v2?.signAndExecuteTransaction) {
				return v2.signAndExecuteTransaction({ transaction, account, chain });
			}

			// CPC Wallet maps v1 block API to the same JSON signer; Transaction.toJSON() works.
			const v1 = currentWallet.features[SIGN_AND_EXECUTE_BLOCK] as
				| {
						signAndExecuteTransactionBlock: (input: {
							transactionBlock: CpcSignableTransaction;
							account: typeof account;
							chain: string;
						}) => Promise<CpcSignAndExecuteResult>;
				  }
				| undefined;
			if (v1?.signAndExecuteTransactionBlock) {
				return v1.signAndExecuteTransactionBlock({
					transactionBlock: transaction,
					account,
					chain,
				});
			}

			throw new Error('当前钱包不支持 signAndExecuteTransaction');
		},
	});
}
